import React, { useState } from 'react';
import {
  Box, FormControlLabel, IconButton, Switch, Table, TableBody, TableCell,
  TableHead, TableRow, TextField, Tooltip, Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import {
  CardWrapper, SectionTitle, ButtonOutlined, FieldLabel, formatBRL,
} from '../../UI';
import * as C from '../../../theme/colors.constants';

/**
 * Aba Dados Jurídicos — print `grid_check_juridico.png`.
 *
 * Dois cards: "Informações" (com o switch de advogado externo, o textarea do
 * detalhe junto ao tribunal e os dois botões de honorários) e "Custas" (tabela
 * vazia com total zerado e o botão "+ NOVO").
 *
 * Os campos ficam desabilitados até o usuário clicar no lápis — é o que o print
 * mostra (fundo cinza) e evita edição acidental.
 */
export default function AbaJuridico() {
  const [editando, setEditando] = useState(false);
  const [advogadoExterno, setAdvogadoExterno] = useState(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 'clamp(10px, 0.8vw, 22px)' }}>
      <CardWrapper>
        <SectionTitle
          right={(
            <Tooltip title={editando ? 'Concluir edição' : 'Editar informações'} arrow>
              <IconButton
                size="small"
                onClick={() => setEditando(v => !v)}
                sx={{
                  color: editando ? C.white : C.navy,
                  backgroundColor: editando ? C.navy : 'transparent',
                  border: `1px solid ${C.borderGrey}`,
                  '&:hover': { backgroundColor: editando ? C.navyDark : C.paleGrey },
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        >
          Informações
        </SectionTitle>

        <FormControlLabel
          control={(
            <Switch
              checked={advogadoExterno}
              disabled={!editando}
              onChange={e => setAdvogadoExterno(e.target.checked)}
            />
          )}
          label={<Typography variant="body2">Advogado Externo Envolvido</Typography>}
          sx={{ mb: 1.5 }}
        />

        <Box sx={{ mb: 2 }}>
          <FieldLabel sx={{ fontWeight: 400, color: C.warmGrey }}>
            Detalhe do Processo Junto ao Tribunal
          </FieldLabel>
          <TextField
            fullWidth
            multiline
            minRows={6}
            disabled={!editando}
            sx={{ '& .MuiInputBase-root.Mui-disabled': { backgroundColor: '#dcdcdc' } }}
          />
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1fr) minmax(0, 1fr)' },
            gap: 'clamp(10px, 0.8vw, 22px)',
            alignItems: 'end',
          }}
        >
          <Box>
            <FieldLabel sx={{ fontWeight: 400, color: C.warmGrey }}>Valor da Causa*</FieldLabel>
            <TextField
              fullWidth
              size="small"
              disabled={!editando}
              defaultValue="R$ 0,00"
              sx={{ '& .MuiInputBase-root.Mui-disabled': { backgroundColor: '#dcdcdc' } }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <ButtonOutlined startIcon={<AccountBalanceIcon />} disabled={!editando}>
              LANÇAR HONORÁRIOS INICIAIS
            </ButtonOutlined>
            <ButtonOutlined startIcon={<AccountBalanceIcon />} disabled={!editando}>
              LANÇAR HONORÁRIOS FINAIS
            </ButtonOutlined>
          </Box>
        </Box>
      </CardWrapper>

      <CardWrapper>
        <SectionTitle right={<ButtonOutlined size="small" startIcon={<AddIcon />}>NOVO</ButtonOutlined>}>
          Custas
        </SectionTitle>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Data</TableCell>
              <TableCell>Histórico</TableCell>
              <TableCell align="right">Valor</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={{ backgroundColor: C.paleGrey }}>
              <TableCell colSpan={2} />
              <TableCell align="right" sx={{ fontWeight: 700 }}>{formatBRL(0)}</TableCell>
              <TableCell />
            </TableRow>
          </TableBody>
        </Table>
      </CardWrapper>
    </Box>
  );
}
